import React, { useState, useRef } from "react";
import {
  AbhaViaSendAadharOtp,
  AbhaViaSendAbhaOtp,
  AlreadyAbhaVerifyAddress,
  AlreadyAbhaVerifyNumber,
  EncryptDataABDM,
  SendAadharOtp,
  UpdateAbhaUserServices,
  VerifyAbhaOtp,
  VerifyAbhaViaSendAadharOtp,
  VerifyAbhaViaSendAbhaAddress,
  VerifyAbhaViaSendAbhaOtp,
  VerifySendAadharOtp,
} from "../../services";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AbhaCardUI from "../Abha-card/abha-card-ui";
import ResendOTPWithTimer from "../../components/resendOTPWithTimer";
import { useDispatch, useSelector } from "react-redux";
import { timerCount } from "../../config";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";
import ComparisonScreen from "../../components/comparision-scrren";
const VerifyNumberAbha = ({
  handleBack,
  inputType = "mobile",
  otpType,
  inputValue,
  setResMessage,
  resMessage,
  selectedAbhaCard,
}) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showCard, setShowCard] = useState(false);
  const [userRes, setUserRes] = useState({});
  const [url, setUrl] = useState("");
  const txnId = localStorage.getItem("txnId");
  const inputsRef = useRef([]);
  const [downloadFlowToken, setDownloadFlowToken] = useState(null);
  const [mobileDownloadFlowToken, setMobileDownloadFlowToken] = useState(null);
  const [showCreateAbha, setShowCreateAbha] = useState(false);
  const dispatch = useDispatch();

  const storedInputValue =
    inputType === "mobile" ? localStorage.getItem("inputValue") : inputValue;

  const resentLeft = useSelector((state) => state.user.resentCount);

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const formatAbhaNumber = (val) => {
    const str = String(val).replace(/-/g, "");
    return str.replace(/^(\d{2})(\d{4})(\d{4})(\d{4})$/, "$1-$2-$3-$4");
  };

  const handleVerify = async () => {
    if (otp.some((val) => val === "")) {
      setError("Please enter the complete 6-digit OTP.");
      return;
    }
    setError("");
    setLoading(true);

    const code = otp.join("");
    try {
      let response;

      if (inputType === "mobile") {
        const response = await VerifyAbhaOtp({
          headers: {},
          data: {
            otp: code,
            txnId,
            name: selectedAbhaCard?.name,
            abhaNumber: selectedAbhaCard?.ABHANumber,
          },
        });
        if (response.success) {
          localStorage.setItem("userData", JSON.stringify(response?.data));
          localStorage.setItem("downloadToken", response.data?.cardToken);
          setDownloadFlowToken(true);
          setShowCard(true);
        } else {
          console.log("3333333333", response);
          toast.error(response?.message || response?.error?.message);
        }
      } else if (inputType === "aadhaar") {
        const encryptedInput = await EncryptDataABDM({ body: code });
        const response = await VerifySendAadharOtp({
          headers: {},
          data: {
            scope: ["abha-login", "aadhaar-verify"],
            authData: {
              authMethods: ["otp"],
              otp: { txnId, otpValue: encryptedInput.data },
            },
          },
        });
        console.log("++++", response);
        if (response.success) {
          localStorage.setItem("userData", JSON.stringify(response?.data));
          localStorage.setItem("downloadToken", response.data?.token);
          setDownloadFlowToken(true);
          setShowCard(true);
        } else {
          console.log("11111111111");
          if (response?.error?.error?.code === "ABDM-1114") {
            console.log("22222222222");

            setShowCreateAbha(true);
            toast.error(response?.error?.error?.message);
          } else {
            console.log("3333333333");
            toast.error(response.data.message || response?.message);
          }
        }
      } else if (inputType === "abha" && otpType === "aadhaar") {
        const encryptedInput = await EncryptDataABDM({ body: code });
        const response = await VerifyAbhaViaSendAadharOtp({
          headers: {},
          data: {
            scope: ["abha-login", "aadhaar-verify"],
            authData: {
              authMethods: ["otp"],
              otp: { txnId, otpValue: encryptedInput.data },
            },
          },
        });
        if (response.success) {
          localStorage.setItem("userData", JSON.stringify(response?.data));
          localStorage.setItem("downloadToken", response.data?.token);
          setDownloadFlowToken(true);
          setShowCard(true);
        } else {
          toast.error(response.data.message);
        }
      } else if (inputType === "abha" && otpType === "abdm") {
        const encryptedInput = await EncryptDataABDM({ body: code });
        const response = await VerifyAbhaViaSendAbhaOtp({
          headers: {},
          data: {
            scope: ["abha-login", "mobile-verify"],
            authData: {
              authMethods: ["otp"],
              otp: { txnId, otpValue: encryptedInput.data },
            },
          },
        });
        if (response.success) {
          localStorage.setItem("userData", JSON.stringify(response?.data));
          localStorage.setItem("downloadToken", response.data?.token);
          setDownloadFlowToken(true);
          setShowCard(true);
        } else {
          toast.error(response.data.message);
        }
      } else if (inputType === "abhaaddress") {
        const encryptedInput = await EncryptDataABDM({ body: code });
        response = await VerifyAbhaViaSendAbhaAddress({
          headers: {},
          data: {
            scope: [
              "abha-address-login",
              otpType === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            ],
            authData: {
              authMethods: ["otp"],
              otp: { txnId, otpValue: encryptedInput.data },
            },
          },
        });
        if (response?.success) {
          localStorage.setItem(
            "userData",
            JSON.stringify(response?.data?.users[0])
          );
          localStorage.setItem("downloadToken", response.data?.tokens?.token);
          setDownloadFlowToken(false);
          setShowCard(true);
        } else {
          toast.error(response?.message || response?.error?.error?.message);
        }
      } else {
        toast.error("Unsupported verification flow");
        return;
      }
    } catch (err) {
      console.error(err, "4444444444444");
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resentLeft <= 0) {
      Swal.fire("Info", "No resend attempts left.", "info");
      return { resent_count: 0 };
    }

    try {
      let response;
      if (inputType === "mobile") {
        const encryptedInput = await EncryptDataABDM({
          body: storedInputValue,
        });
        response = await AlreadyAbhaVerifyNumber({
          headers: {},
          data: {
            scope: ["abha-login", "mobile-verify"],
            loginHint: "mobile",
            loginId: encryptedInput.data,
            otpSystem: "abdm",
          },
        });
      } else if (inputType === "aadhaar") {
        const encryptedInput = await EncryptDataABDM({
          body: storedInputValue,
        });
        response = await SendAadharOtp({
          headers: {},
          data: {
            scope: ["abha-login", "aadhaar-verify"],
            loginHint: "aadhaar",
            loginId: encryptedInput.data,
            otpSystem: "aadhaar",
          },
        });
      } else if (inputType === "abha" && otpType === "aadhaar") {
        const encryptedInput = await EncryptDataABDM({
          body: formatAbhaNumber(storedInputValue),
        });
        response = await AbhaViaSendAadharOtp({
          headers: {},
          data: {
            scope: ["abha-login", "aadhaar-verify"],
            loginHint: "abha-number",
            loginId: encryptedInput.data,
            otpSystem: "aadhaar",
          },
        });
      } else if (inputType === "abha" && otpType === "abdm") {
        const encryptedInput = await EncryptDataABDM({
          body: formatAbhaNumber(storedInputValue),
        });
        response = await AbhaViaSendAbhaOtp({
          headers: {},
          data: {
            scope: ["abha-login", "mobile-verify"],
            loginHint: "abha-number",
            loginId: encryptedInput.data,
            otpSystem: "abdm",
          },
        });
      } else if (inputType === "abhaaddress") {
        const encryptedInput = await EncryptDataABDM({
          body: formatAbhaNumber(storedInputValue),
        });
        response = await AlreadyAbhaVerifyAddress({
          headers: {},
          data: {
            scope: [
              "abha-address-login",
              otpType === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            ],
            loginHint: "abha-address",
            loginId: encryptedInput.data,
            otpSystem: otpType === "aadhaar" ? "aadhaar" : "abdm",
          },
        });
        // if (response.success) {
        //   localStorage.setItem("downloadToken", response.data?.tokens?.token);
        //   setDownloadFlowToken(true);
        //   setShowCard(true);
        // }
      } else {
        toast.error("Unsupported resend flow");
        return { resent_count: resentLeft };
      }

      const newTxnId = response?.data?.txnId;
      if (newTxnId) localStorage.setItem("txnId", newTxnId);
      if (response?.success || response?.data?.success) {
        toast.success("OTP resent successfully.");
        setOtp(Array(6).fill(""));
        setShowCard(false);
        setError("");
      } else {
        setError(
          response?.data?.message || response?.message || "Failed to resend OTP"
        );
      }

      return { resent_count: resentLeft - 1 };
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to resend OTP");
      return { resent_count: resentLeft - 1 };
    }
  };

  const handleCloseCard = () => {
    setShowCard(false);
    window.location.reload();
  };

  return (
    <div className="col-md-6">
      {!showCard ? (
        <div className="form-card content otp-container2">
          <h3 className="custom2-h3">Verify your details</h3>
          <p>{resMessage || "Enter OTP sent to your linked mobile number"}</p>

          <div className="otp-inputs">
            {otp.map((digit, i) => (
              <input
                key={i}
                ref={(el) => (inputsRef.current[i] = el)}
                type="text"
                maxLength={1}
                value={digit}
                autoComplete="off"
                onChange={(e) => handleChange(i, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                className="otp-box"
              />
            ))}
          </div>

          {error && (
            <div className="text-danger py-2" style={{ fontSize: "14px" }}>
              {error}
            </div>
          )}

          <ResendOTPWithTimer
            onResendClick={handleResendOtp}
            cooldownSeconds={timerCount}
          />

          <div className="button-group">
            <button className="btn btn-back" onClick={handleBack}>
              BACK
            </button>
            <button
              className={`btn ${
                otp.every((val) => val !== "") && !loading
                  ? "btn-active"
                  : "btn-disabled"
              }`}
              onClick={handleVerify}
              disabled={otp.some((val) => val === "") || loading}
            >
              {loading ? "Verifying..." : "VERIFY"}
            </button>
          </div>
          {showCreateAbha && (
            <p className="text-center mt-3">
              Don't have a ABHA?{" "}
              <span
                className="resend-message cursor-pointer"
                onClick={() => {
                  dispatch(setGlobalCurrentStep("SendAdharOTP"));
                }}
              >
                Create New
              </span>
            </p>
          )}
        </div>
      ) : (
        <>
          {inputType === "mobile" ? (
            <ComparisonScreen
              downloadFlowToken={downloadFlowToken}
              selectedAbhaCard={selectedAbhaCard}
            />
          ) : (
            <AbhaCardUI downloadFlowToken={downloadFlowToken}  inputType={inputType}/>
          )}
        </>
      )}
    </div>
  );
};

export default VerifyNumberAbha;
